import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { IRootState, AppDispatch } from "./store";

export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();